import React from 'react';
import { NotFoundPage as NotFoundPageScreen } from '@features/not-found-page';

export const NotFoundPage = (props: any) => <NotFoundPageScreen {...props} />;
